import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      light: "#82e1e5",
      main: "#329fa5",
      dark: "#3c7b7aff",
    },
    secondary: {
      light: "#bae6ff",
      main: "#5ea3d7",
      dark: "#3e5786",
    },
    
  }
});